import {
  ITEM_TYPE_CONFIRMATION_MAIL,
  ITEM_TYPE_FORM,
  ITEM_TYPE_PAGE,
  ITEM_TYPE_MAIL,
  ITEM_TYPE_RESPONDER,
  ITEM_TYPE_LANDING_PAGE,
  ITEM_TYPE_LANDING_PAGE_SUCCESS,
  ITEM_TYPE_SURVEY,
  ITEM_TYPE_SURVEY_THANK_YOU,
} from '@client/components/Editor/settings'

export const STATIC_ATTRIBUTES = [
  { name: 'contactattrs.static.attributes.view_online', code: 'view_online' },
  { name: 'contactattrs.static.attributes.unsubscribe', code: 'unsubscribe' },
  {
    name: 'contactattrs.static.attributes.update_contact',
    code: 'update_contact',
  },
  { name: 'contactattrs.static.attributes.firstname', code: 'firstname' },
  { name: 'contactattrs.static.attributes.lastname', code: 'lastname' },
  { name: 'contactattrs.static.attributes.email', code: 'email' },
  { name: 'contactattrs.static.attributes.sms_number', code: 'sms_number' },
  {
    name: 'contactattrs.static.attributes.confirmation_link',
    code: 'confirmation_link',
  },
]

export const JSFORMS_STATIC_ATTRIBUTES = [
  { name: 'contactattrs.static.attributes.list_name', code: 'list_name' },
  { name: 'contactattrs.static.attributes.sender_name', code: 'sender_name' },
]

export const STATIC_ATTRIBUTES_BY_TYPE = {
  [ITEM_TYPE_MAIL]: STATIC_ATTRIBUTES,
  [ITEM_TYPE_RESPONDER]: STATIC_ATTRIBUTES,
  [ITEM_TYPE_CONFIRMATION_MAIL]: [
    { name: 'contactattrs.static.attributes.firstname', code: 'firstname' },
    { name: 'contactattrs.static.attributes.lastname', code: 'lastname' },
    { name: 'contactattrs.static.attributes.email', code: 'email' },
    { name: 'contactattrs.static.attributes.sms_number', code: 'sms_number' },
    { name: 'contactattrs.static.attributes.list_name', code: 'list_name' },
    { name: 'contactattrs.static.attributes.sender_name', code: 'sender_name' },
    {
      name: 'contactattrs.static.attributes.confirmation_link',
      code: 'confirmation_link',
    },
  ],
  [ITEM_TYPE_FORM]: [
    { name: 'contactattrs.static.attributes.firstname', code: 'firstname' },
    { name: 'contactattrs.static.attributes.lastname', code: 'lastname' },
    { name: 'contactattrs.static.attributes.email', code: 'email' },
    { name: 'contactattrs.static.attributes.sms_number', code: 'sms_number' },
    { name: 'contactattrs.static.attributes.list_name', code: 'list_name' },
    { name: 'contactattrs.static.attributes.sender_name', code: 'sender_name' },
  ],
  [ITEM_TYPE_PAGE]: [
    { name: 'contactattrs.static.attributes.firstname', code: 'firstname' },
    { name: 'contactattrs.static.attributes.lastname', code: 'lastname' },
    { name: 'contactattrs.static.attributes.email', code: 'email' },
    { name: 'contactattrs.static.attributes.sms_number', code: 'sms_number' },
    { name: 'contactattrs.static.attributes.list_name', code: 'list_name' },
    { name: 'contactattrs.static.attributes.sender_name', code: 'sender_name' },
  ],
  [ITEM_TYPE_LANDING_PAGE]: [
    { name: 'contactattrs.static.attributes.firstname', code: 'firstname' },
    { name: 'contactattrs.static.attributes.lastname', code: 'lastname' },
    { name: 'contactattrs.static.attributes.email', code: 'email' },
    { name: 'contactattrs.static.attributes.sms_number', code: 'sms_number' },
    { name: 'contactattrs.static.attributes.list_name', code: 'list_name' },
    { name: 'contactattrs.static.attributes.sender_name', code: 'sender_name' },
  ],
  [ITEM_TYPE_LANDING_PAGE_SUCCESS]: [
    { name: 'contactattrs.static.attributes.firstname', code: 'firstname' },
    { name: 'contactattrs.static.attributes.lastname', code: 'lastname' },
    { name: 'contactattrs.static.attributes.email', code: 'email' },
    { name: 'contactattrs.static.attributes.sms_number', code: 'sms_number' },
    { name: 'contactattrs.static.attributes.list_name', code: 'list_name' },
    { name: 'contactattrs.static.attributes.sender_name', code: 'sender_name' },
  ],
  [ITEM_TYPE_SURVEY]: [
    { name: 'contactattrs.static.attributes.firstname', code: 'firstname' },
    { name: 'contactattrs.static.attributes.lastname', code: 'lastname' },
    { name: 'contactattrs.static.attributes.email', code: 'email' },
    { name: 'contactattrs.static.attributes.sms_number', code: 'sms_number' },
    { name: 'contactattrs.static.attributes.list_name', code: 'list_name' },
    { name: 'contactattrs.static.attributes.sender_name', code: 'sender_name' },
  ],
  [ITEM_TYPE_SURVEY_THANK_YOU]: [
    { name: 'contactattrs.static.attributes.firstname', code: 'firstname' },
    { name: 'contactattrs.static.attributes.lastname', code: 'lastname' },
    { name: 'contactattrs.static.attributes.email', code: 'email' },
    { name: 'contactattrs.static.attributes.sms_number', code: 'sms_number' },
    { name: 'contactattrs.static.attributes.list_name', code: 'list_name' },
    { name: 'contactattrs.static.attributes.sender_name', code: 'sender_name' },
  ],
}
